import "./LoadIcon.scss";
import CircularProgress from "@mui/material/CircularProgress";
export function LoadIcon() {
  return (
    <div className="align-center">
      <CircularProgress size={25} thickness={8} />
    </div>
  );
}
